export const NUMBER = "[-+]?(?:\\d+\\.?\\d*|\\.\\d+)";

// "x y m x y l" (same point), optionally closed with "h", directly followed by a stroking
// paint operator (S, s, B, B*, b, b*). Group 1 is the whitespace (or start) before the
// path, so no lookbehind is needed. The end points are compared as numbers in the callback.
export const ZERO_LENGTH_STROKE = new RegExp(
  `(^|\\s)(${NUMBER})\\s+(${NUMBER})\\s+m\\s+(${NUMBER})\\s+(${NUMBER})\\s+l(?:\\s+h)?\\s+(S|s|B\\*?|b\\*?)(?=[\\s\\[/(<]|$)`,
  "g"
);

export const DOT_SEGMENT_LENGTH = 0.01;
export const MAX_COORDINATE = 1e9;
export const STREAM_ENCODING_KEYS = ["/Filter", "/DecodeParms", "/Length"];
export const CHUNK_SIZE = 0x8000;

// The patch is only for display; skip it rather than risk freezing the tab.
export const MAX_INPUT_BYTES = 40 * 1024 * 1024;
export const MAX_DECODED_BYTES = 200 * 1024 * 1024;
export const YIELD_AFTER_MS = 30;
